import { z } from 'zod';

const historyStateSchema = z.object({ idx: z.number() });

/**
 * react-routerが管理するhistory.stateのidxを検証し、
 * ブラウザバックで戻れる履歴があるかを判定する
 */
const canGoBack = (): boolean => {
  const result = historyStateSchema.safeParse(window.history.state);
  return result.success && result.data.idx > 0;
};

export default canGoBack;
